import * as APIModels from './api';
import * as HelpersModels from './helpers';
import * as InternalModels from './internal';

export namespace TSP {
  export import API = APIModels.API;
  export import Internal = InternalModels.Internal;
  export import Helpers = HelpersModels;
}
